import { useCallback } from 'react'
import {
	ApiGetNoToken, ApiGetFileNoToken,
  ApiGetWithToken,
  ApiGetFileWithToken,
  ApiPostFileWithToken,
	useApiFetch,
	useApiPost,
	FileResponse,
	ApiPostWithToken,
	ApiPatchWithToken
} from 'shared/api'
import {
	openTenantApi,
  tenantApi,
  tenantApiBy
} from 'interface/endpoints'
import {
	TenantDetailResult,
  TenantFormData,
  TenantResult,
  TenantResultList
} from './types'
import { CancelToken } from 'axios'
import { ApiAccess } from 'features/session/types'

export * from './types'

export const GetTenant = (
  domain: string
) => ApiGetNoToken<TenantResult>(
  openTenantApi(domain, '')
)

export const GetTenantBackground = (
  domain: string
) => ApiGetFileNoToken(
  openTenantApi(domain, '/background')
)

export const GetTenantBanner = (
  domain: string
) => ApiGetFileNoToken(
  openTenantApi(domain, '/bunner')
)

export const GetTenantTheme = (
  domain: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) => ApiGetNoToken<any>(
  openTenantApi(domain, '/theme')
)

export const useListTenant = (
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      return ApiGetWithToken<TenantResultList>(
        apiAccess,
        tenantApi('/list'),
        cancelToken
      )
    },
		[]
	)
)

export const useGetTenant = (
  tenantId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      if (!tenantId) return null
      return ApiGetWithToken<TenantDetailResult>(
        apiAccess,
        tenantApiBy(tenantId),
        cancelToken
  		)
    },
		[tenantId]
	)
)

export const useGetManualURL = (
  tenantId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      if (!tenantId) return null
      return ApiGetWithToken<string>(
        apiAccess,
        tenantApiBy(tenantId, '/manual'),
        cancelToken
  		)
    },
		[tenantId]
	)
)

export const useGetTenantBackground = (
	tenantId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!tenantId) return null
			return ApiGetFileWithToken(
				apiAccess,
				tenantApiBy(tenantId, '/background'),
				cancelToken
			)
		},
		[tenantId]
	)
)

const postTenantBackground = (
	apiAccess: ApiAccess,
	tenantId: number,
	file: File, 
	cancelToken?: CancelToken,
	webSocketId?: string
) => {
	const formData = new FormData()
	formData.append('file', file)
	return ApiPostFileWithToken(
		apiAccess,
		tenantApiBy(tenantId, '/background'),
		formData,
		cancelToken,
		webSocketId
	)
}
export const useSetTenantBackground = (
  tenantId: number, 
	callback?: {
    onPosted?: (result: FileResponse) => void
    onError?: (reason: Error | undefined) => void
  }
) => useApiPost<File, FileResponse>(
	useCallback(
		(apiAccess, cancelToken, file, webSocketId) => 
			postTenantBackground(apiAccess, tenantId, file, cancelToken, webSocketId),
		[tenantId]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useGetTenantBunner = (
	tenantId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!tenantId) return null
			return ApiGetFileWithToken(
				apiAccess,
				tenantApiBy(tenantId, '/bunner'),
				cancelToken
			)
		},
		[tenantId]
	)
)

const postTenantBunner = (
	apiAccess: ApiAccess,
	tenantId: number,
	file: File, 
	cancelToken?: CancelToken,
	webSocketId?: string
) => {
	const formData = new FormData()
	formData.append('file', file)
	return ApiPostFileWithToken(
		apiAccess,
		tenantApiBy(tenantId, '/bunner'),
		formData,
		cancelToken,
		webSocketId
	)
}
export const useSetTenantBunner = (
  tenantId: number,
	callback?: {
    onPosted?: (result: FileResponse) => void
    onError?: (reason: Error | undefined) => void
  }
) => useApiPost<File, FileResponse>(
	useCallback(
		(apiAccess, cancelToken, file, webSocketId) =>
			postTenantBunner(apiAccess, tenantId, file, cancelToken, webSocketId),
		[tenantId]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useGetTenantShortBunner = (
	tenantId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!tenantId) return null
			return ApiGetFileWithToken(
				apiAccess,
				tenantApiBy(tenantId, '/bunner-s'),
				cancelToken
			)
		},
		[tenantId]
	)
)

const postTenantShortBunner = (
	apiAccess: ApiAccess,
	tenantId: number,
	file: File, 
	cancelToken?: CancelToken,
	webSocketId?: string
) => {
	const formData = new FormData()
	formData.append('file', file)
	return ApiPostFileWithToken(
		apiAccess,
		tenantApiBy(tenantId, '/bunner-s'),
		formData,
		cancelToken,
		webSocketId
	)
}
export const useSetTenantShortBunner = (
  tenantId: number,
	callback?: {
    onPosted?: (result: FileResponse) => void
    onError?: (reason: Error | undefined) => void
  }
) => useApiPost<File, FileResponse>(
	useCallback(
		(apiAccess, cancelToken, file, webSocketId) =>
			postTenantShortBunner(apiAccess, tenantId, file, cancelToken, webSocketId),
		[tenantId]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const usePostTenant = (
	callback?: {
		onPosted?: (
			result: TenantDetailResult,
			backgroundResult?: FileResponse,
			bunnerResult?: FileResponse,
			shortBunnerResult?: FileResponse
		) => void
		onError?: (reason: Error | undefined) => void
	}
) => useApiPost<{
	form: TenantFormData
	background: File | null
	bunner: File | null
	shortBunner: File | null
}, TenantDetailResult>(
	useCallback(
		(apiAccess, cancelToken, { form }, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
				tenantApi(),
				form,
				cancelToken,
				webSocketId
			)
		},
		[]
	),
	useCallback(
		async (result, { background, bunner, shortBunner }, apiAccess, cancelToken) => {
			const backgroundResult = background ?
				await postTenantBackground(apiAccess, result.tenantId, background, cancelToken) :
				undefined
			const bunnerResult = bunner ?
				await postTenantBunner(apiAccess, result.tenantId, bunner, cancelToken) :
				undefined
			const shortBunnerResult = shortBunner ?
				await postTenantShortBunner(apiAccess, result.tenantId, shortBunner, cancelToken) :
				undefined
			if (callback?.onPosted) callback.onPosted(result, backgroundResult, bunnerResult, shortBunnerResult)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
			if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useEditTenant = (
	tenantId: number,
	callback?: {
		onEditted?: (result: TenantDetailResult) => void
		onError?: (reason: Error | undefined) => void
	}
) => useApiPost<TenantFormData, TenantDetailResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPatchWithToken(
				apiAccess,
				tenantApiBy(tenantId),
				form,
				cancelToken,
				webSocketId
			)
		},
		[tenantId]
	),
	useCallback(
		(result) => {
			if (callback?.onEditted) callback.onEditted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
			if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

